import moment from 'moment-timezone';
import DateTimeClient from '@/api/DateTimeClient'

export default function() {
  return {
    data() {
      return {
        client: new DateTimeClient(this.$http),
        delta: null,

        momentDefaultNow: moment.now,
        deltaUnits: 'hours',
        utcOffsetMinutesInHour: -60,
      }
    },
    methods: {
      async initialize() {
        try {
          const server = await this.server()
          const local = this.local();

          this.delta = Math.round(local.diff(server, this.deltaUnits, true))
          
          if(this.delta !== 0)
            this.adjustMomentTimeZoneAndNowToMatchServer(local, server);
          else
            moment.tz.setDefault(moment.tz.guess())
        } catch (ex) {
          console.error(ex);
        }
      },
      adjustMomentTimeZoneAndNowToMatchServer(local, server) {
        const localTimeZone = moment.tz.zone(moment.tz.guess());
        const localOffset = localTimeZone.utcOffset(moment().valueOf()) / this.utcOffsetMinutesInHour;

        const correctedOffset = localOffset + this.delta;

        const potentialOffsets = moment.tz.zonesForCountry('US', true);
        const potentialOffset = potentialOffsets.find(x => x.offset / this.utcOffsetMinutesInHour == correctedOffset);
        const potentialZone = moment.tz.zone(potentialOffset.name);

        moment.tz.setDefault(potentialZone.name);
        moment.now = () => this.momentDefaultNow() - (this.delta * 3600000);

        const adjustedTime = moment();
        const adjustedTimeZone = adjustedTime._z;

        const warning = `[BetterMynd] Time mismatch: ${this.delta} hour(s)\r\n`
          + `\tLocal Time  UTC:\t${local.toISOString()}\r\n`
          + `\tLocal Time Zone:\t${localTimeZone.name} (${localTimeZone.utcOffset(local.valueOf()) / this.utcOffsetMinutesInHour})\r\n`
          + `\tServer Time  UTC:\t${server.toISOString()}\r\n`
          + `\tWanted Time Zone:\t${potentialZone.name} (${potentialZone.utcOffset(server.valueOf()) / this.utcOffsetMinutesInHour})\r\n`
          + `\tAdjusted Time  UTC:\t${adjustedTime.toISOString()}\r\n`
          + `\tAdjusted Time Zone:\t${adjustedTimeZone.name} (${adjustedTimeZone.utcOffset(local.valueOf()) / this.utcOffsetMinutesInHour})`;
        console.warn(warning);

      },
      timezone() {
        const tz = moment()._z;
        if(tz)
          return tz;
        
        return moment.tz.zone(moment.tz.guess());
      },
      local(...args) {
        return moment(...args)
      },
      async server() {
        const response = await this.client.getCurrentDateTime();
        return moment(response.now);
      },
    }
  }
}